export async function fetchTeams() {
    try {
        const res = await fetch('/teams/equipes.json', { cache: 'no-store' }); // no-store pour dev, retirez si cache voulu
        if (!res.ok) {
            throw new Error(`Fetch team failed: ${res.status}`);
        }
        const data = await res.json();
        return data.equipes || [];
    } catch (err) {
        console.error(err);
        return [];
    }
}